import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { intlShape } from 'react-intl';
import { TextField, Utils } from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import Form from '@control-front-end/forms';
import { DEFAULT_FORM_TITLE } from '@control-front-end/common/constants/forms';
import Title from '@control-front-end/common/components/Title';
import AccessRules from '@control-front-end/common/components/AccessRules';
import Panel from './components/Panel';
import FormEdit from './components/FormEdit';
import FormSettings from './components/FormSettings';
import FormAccounts from './components/FormAccounts';
import FormActions from './FormActions';
import mes from './intl';
import './FormConstructor.scss';

class FormConstructor extends Component {
  // Ф-ция локализации
  i(mesId, values) {
    return AppUtils.getMes(this.context)(mesId, values);
  }

  renderTitlePortal() {
    const {
      titlePortal,
      form,
      canEdit,
      defaultTitle,
      titleType,
      handleFormField,
      isNew,
    } = this.props;
    if (!titlePortal) return;
    return ReactDOM.createPortal(
      <Title
        title={form.title || defaultTitle || this.i(mes[DEFAULT_FORM_TITLE])}
        type={titleType}
        canEdit={canEdit}
        readOnly={!canEdit}
        isNew={isNew && form.title === this.i(mes[DEFAULT_FORM_TITLE])}
        nullable={true}
        singleLine={true}
        onSubmit={(value) => {
          handleFormField({
            id: 'title',
            value: value || this.i(mes[DEFAULT_FORM_TITLE]),
          });
        }}
      />,
      titlePortal
    );
  }

  renderConstructor() {
    const {
      form,
      activeSection,
      activeItem,
      showPanel,
      isTemplate,
      errorsChecked,
    } = this.props;
    const section = form.sections[activeSection];
    const item = section ? section.content[activeItem] : {};
    return (
      <div styleName="cf__editor">
        <div styleName="cf__editor__main">
          <FormEdit
            activeSection={activeSection}
            activeItem={activeItem}
            sections={form.sections}
            errors={item.errors}
            isTemplate={isTemplate}
            errorsChecked={errorsChecked}
            onChange={this.props.handleOnChangeItem}
            onActive={this.props.handelOnActive}
            onCreateSection={this.props.handleAddSection}
            onRemoveSection={this.props.handleRemoveSection}
            onSortSection={this.props.handleSortSection}
            onRenameSection={this.props.handleRenameSection}
            onCreateItem={this.props.handleAddItem}
            onRemoveItem={this.props.handleRemoveItem}
            onSortItem={this.props.handleSortItem}
            onShowPanel={this.props.handleTogglePanel}
            onCreateTemplate={this.props.handleMakeSectionTemplate}
          />
        </div>
        {showPanel ? (
          <div styleName="cf__editor__panel">
            <Panel
              sections={form.sections}
              onChange={this.props.handleOnChangeItem}
              onShowPanel={this.props.handleTogglePanel}
              {...item}
            />
          </div>
        ) : null}
      </div>
    );
  }

  renderSettings() {
    const { form } = this.props;
    return (
      <FormSettings
        color={form.color}
        description={form.description}
        handleFormField={this.props.handleFormField}
      />
    );
  }

  renderPreview() {
    const { form } = this.props.getForm();
    return (
      <div styleName="cf__preview">
        <div styleName="cf__preview__main">
          <Form
            form={form}
            type="modal"
            extraSection={
              <div styleName="cf__preview__extra">
                <TextField
                  bordered={true}
                  label="Title"
                  value=""
                  visibility="disabled"
                />
                <TextField
                  bordered={true}
                  label="Description"
                  value=""
                  visibility="disabled"
                />
              </div>
            }
          />
        </div>
      </div>
    );
  }

  renderAccess() {
    const { access, ownerId, accountOwnerId, handleChangeAccess } = this.props;
    return (
      <AccessRules
        styleType="embeded"
        rules={access}
        ownerId={ownerId}
        accountOwnerId={accountOwnerId}
        onChange={handleChangeAccess}
      />
    );
  }

  renderActorsAccess() {
    const { actorsAccess, ownerId, accountOwnerId, handleChangeActorsAccess } =
      this.props;
    return (
      <AccessRules
        styleType="embeded"
        rules={actorsAccess}
        ownerId={ownerId}
        accountOwnerId={accountOwnerId}
        disableOwner={false}
        filterTypes={null}
        onChange={handleChangeActorsAccess}
      />
    );
  }

  renderAccounts() {
    const { formAccounts, handleChangeAccounts } = this.props;
    return (
      <FormAccounts
        formAccounts={formAccounts}
        handleChangeAccounts={handleChangeAccounts}
      />
    );
  }

  render() {
    const { action } = this.props;
    const func = `render${Utils.toUpperLatter(action)}`;
    return (
      <>
        {this[func]()}
        {this.renderTitlePortal()}
      </>
    );
  }
}

FormConstructor.defaultProps = {
  action: 'constructor',
  titleType: 'primary',
  isNew: false,
};

FormConstructor.propTypes = {
  action: PropTypes.oneOf([
    'constructor',
    'preview',
    'settings',
    'access',
    'actorsAccess',
    'accounts',
  ]),
  showPanel: PropTypes.bool,
  form: PropTypes.object,
  access: PropTypes.array,
  actorsAccess: PropTypes.array,
  formAccounts: PropTypes.array,
  canEdit: PropTypes.bool,
  ownerId: PropTypes.number,
  activeSection: PropTypes.number,
  activeItem: PropTypes.number,
  defaultTitle: PropTypes.string,
  titleType: PropTypes.string,
  titlePortal: PropTypes.any,
  isNew: PropTypes.bool,
  isTemplate: PropTypes.bool,
  errorsChecked: PropTypes.bool,
  handleTogglePanel: PropTypes.func,
  handleOnChangeItem: PropTypes.func,
  handelOnActive: PropTypes.func,
  handleSortSection: PropTypes.func,
  handleRenameSection: PropTypes.func,
  handleAddSection: PropTypes.func,
  handleRemoveSection: PropTypes.func,
  handleAddItem: PropTypes.func,
  handleRemoveItem: PropTypes.func,
  handleSortItem: PropTypes.func,
  handleMakeSectionTemplate: PropTypes.func,
  handleFormField: PropTypes.func,
  handleChangeAccess: PropTypes.func,
  handleChangeActorsAccess: PropTypes.func,
  handleChangeAccounts: PropTypes.func,
  getForm: PropTypes.func,
};

FormConstructor.contextTypes = {
  intl: intlShape,
};

export default FormActions(FormConstructor);
